import { WS_PROTOCOL } from "../utils/environment";
import { getAccessToken } from "../utils/auth";

const url = `${WS_PROTOCOL}://${window.location.host}/ws/sod`;

class SodSocketService {
    constructor() {
        this._socket = null;
        this._sessionId = null
        this._subMap = {};
        this._token = null
    }

    static _service = null

    static getInstance(){
        if (!SodSocketService._service){
            SodSocketService._service = new SodSocketService()
        }

        return SodSocketService._service;
    }

    _createSocket(){
        if (this._socket) return Promise.resolve()
         
        return new Promise((res, rej) => {
            const token = getAccessToken();

            if (!token) {
                rej()
                return
            }

            const socket_url = url + `?token=${token}`

            const socket = new WebSocket(socket_url);

            socket.onopen = () => {
                this._socket = socket;
                this._token = token
                res(this._socket)
            }

            socket.onerror = (err) => {
                console.log(err)
                rej()
            }

            socket.onclose = () => {
                this._socket = null;
                this._subMap = {};
            }

            socket.onmessage = (msgData) => {
                this.onMessage(msgData)
            }
        })
    }

    _getSocket(connectIfNotExist=true) {
        // const token = getAccessToken();

        // if (!token) {
        //     return Promise.reject()
        // }

        // if (this._token !== token){
        //     return this._createSocket()
        // }
        
        if (this._socket || !connectIfNotExist){
            return Promise.resolve(this._socket)
        }

        return this._createSocket()
    }

    async connect(){
        return await this._createSocket()
    }

    async onMessage(msgData){
        console.log(msgData)

        const msgParsed = JSON.parse(msgData.data)
        
        switch(msgParsed["path"]){
            case "initial":
                this._sessionId = msgParsed["session_id"]
                return
            case "no_auth":
                console.log("no auth")
                return
        }

        if (!this._subMap[msgParsed["path"]]) return

        this._subMap[msgParsed["path"]].forEach(callback => {
            callback(msgParsed["payload"])
        })
    }

    async subscribe(path, callback){
        if (path === "initial") return

        if (!this._subMap[path]){
            this._subMap[path] = []
        }

        this._subMap[path].push(callback)

    }

    async unsubscribe(path, callback){
        if (!this._subMap[path]) return

        this._subMap[path] = this._subMap[path].filter(item => item != callback)
    }

    async getSessionId(){
        const socket = await this._getSocket();

        if (!socket) return null;
        
        return this._sessionId
    }


    async closeConnection(code, message) {
        const socket = await this._getSocket(false);

        if (!socket) return;
        
        socket.close(code, message);
    }

    async sendAction(actionId, payload){
        const socket = await this._getSocket();
        const accessToken = getAccessToken();

        const message = {
            jwt: accessToken,
            action_id: actionId,
            payload: payload
        }

        socket.send(JSON.stringify(message));
    }
}

export default SodSocketService